import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import {
	AverageCalculateRequest,
	AverageCalculateResponse,
	AverageMix,
	CancelAverageMixRequest,
	ExecuteAverageMixRequest,
	IAverageMixByIdResponse,
	IAverageMixCreateRequest,
	IAverageMixQueryRequest,
	IAverageMixQueryResponse
} from "../interfaces/average-mix.interface";
import { IFilterAverageMixRequest } from "../interfaces/filter.interface";
import { IResponseData, IResponseListDataPaginate } from "../interfaces/response-data.interface";

@Injectable({
	providedIn: "root"
})
export class AverageMixService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	getAll(request: IAverageMixQueryRequest): Observable<IResponseListDataPaginate<IAverageMixQueryResponse>> {
		let params = new HttpParams();
		if (request.averagemixname !== "" && request.averagemixname !== undefined && request.averagemixname !== null) {
			params = params.append("averagemixname", request.averagemixname);
		}
		if (request.takername !== "" && request.takername !== undefined && request.takername !== null) {
			params = params.append("takername", request.takername);
		}
		if (request.brokername !== "" && request.brokername !== undefined && request.brokername !== null) {
			params = params.append("brokername", request.brokername);
		}
		if (
			request.idsegmentacaoclientes !== "" &&
			request.idsegmentacaoclientes !== undefined &&
			request.idsegmentacaoclientes !== null
		) {
			params = params.append("idsegmentacaoclientes", request.idsegmentacaoclientes);
		}
		if (request.initialdate !== "" && request.initialdate !== undefined && request.initialdate !== null) {
			params = params.append("initialdate", request.initialdate);
		}
		if (request.finaldate !== "" && request.finaldate !== undefined && request.finaldate !== null) {
			params = params.append("finaldate", request.finaldate);
		}
		if (request.productid !== "" && request.productid !== undefined && request.productid !== null) {
			params = params.append("productid", request.productid);
		}
		if (request.coverageid !== "" && request.coverageid !== undefined && request.coverageid !== null) {
			params = params.append("coverageid", request.coverageid);
		}
		if (request.typerid !== "" && request.typerid !== undefined && request.typerid !== null) {
			params = params.append("typerid", request.typerid);
		}
		if (request.status !== "" && request.status !== undefined && request.status !== null) {
			params = params.append("status", request.status);
		}
		if (request.page !== undefined) {
			params = params.append("page", request.page.toString());
		}
		if (request.pageSize !== undefined) {
			params = params.append("pageSize", request.pageSize.toString());
		}
		return this.http.get<IResponseListDataPaginate<IAverageMixQueryResponse>>(
			`${environment.urlApi}/AverageMixByFilter`,
			{ params }
		);
	}

	getById(id: number): Observable<IResponseData<IAverageMixByIdResponse>> {
		return this.http.get<IResponseData<IAverageMixByIdResponse>>(`${environment.urlApi}/GetAverageMixById?id=${id}`);
	}

	getToName(request: IFilterAverageMixRequest): Observable<any> {
		let params = new HttpParams();

		if (request.name !== "" && request.name !== undefined) {
			params = params.append("name", request.name);
		}

		return this.http.get<any>(`${environment.urlApi}/AverageMixGetByName`, { params });
	}

	update(request: IAverageMixCreateRequest): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/UpdateAverageMix`, request);
	}

	disable(request: any): Observable<any> {
		return this.http.put<any>(`${environment.urlApi}/AverageMix/Disable`, request);
	}

	post(request: IAverageMixCreateRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/insertaveragemix`, request);
	}

	get(request: any): Observable<IResponseData<AverageMix>> {
		return this.http.post<IResponseData<AverageMix>>(`${environment.urlApi}/AverageMix`, request);
	}

	calculate(request: AverageCalculateRequest): Observable<AverageCalculateResponse> {
		return this.http.post<AverageCalculateResponse>(`${environment.urlApi}/AverageMix/Calculate`, request);
	}

	execute(request: ExecuteAverageMixRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/AverageMix/Execute`, request);
	}

	cancel(request: CancelAverageMixRequest): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/AverageMix/Cancel`, request);
	}

	getAverageMixAplicationList(): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/AverageMixAplication`, {});
	}

	getAverageMixTypeList(): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/AverageMixType`, {});
	}
	getAverageMixContentList(): Observable<any> {
		return this.http.post<any>(`${environment.urlApi}/AverageMixContent`, {});
	}
}
